import { useState } from 'react';
import { ChevronDown, ChevronUp, X } from 'lucide-react';
import type { BulkEditFailedMeeting, BulkEditErrorToastProps } from '@/types/draftCalendar';

export function BulkEditErrorToast({ failedCount, totalCount, failedMeetings, onClose }: BulkEditErrorToastProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: 'fixed',
        top: 64,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 200,
        borderRadius: 6,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        backgroundColor: '#FBA5A2',
        border: '1px solid #E57373',
        fontSize: 14,
        color: '#4A1C1A',
        width: expanded ? 600 : undefined,
        maxWidth: '90vw',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', padding: '10px 16px', gap: 10 }}>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9.75 12.75H8.25V11.25H9.75V12.75ZM9.75 9.75H8.25V5.25H9.75V9.75Z" fill="#4A1C1A" />
        </svg>
        <span style={{ flex: 1 }}>
          <strong>{failedCount}</strong> of <strong>{totalCount}</strong> meetings were not saved
        </span>
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2, display: 'flex', alignItems: 'center', gap: 4, color: '#4A1C1A', fontWeight: 600, fontSize: 13 }}
        >
          Details
          {expanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </button>
        <button
          type="button"
          onClick={onClose}
          aria-label="Dismiss error message"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2, display: 'flex', color: '#4A1C1A' }}
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      {expanded && failedMeetings.length > 0 && (
        <div style={{ maxHeight: 240, overflowY: 'auto', borderTop: '1px solid #E57373' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, tableLayout: 'fixed' }}>
            <thead>
              <tr style={{ backgroundColor: '#E8E8E8', textAlign: 'left', borderBottom: '1px solid #D0D0CE' }}>
                <th style={{ padding: '6px 12px', fontWeight: 600, color: '#000000', width: '5%' }}>#</th>
                <th style={{ padding: '6px 12px', fontWeight: 600, color: '#000000', width: '30%' }}>Meeting Name</th>
                <th style={{ padding: '6px 12px', fontWeight: 600, color: '#000000', width: '30%' }}>Date</th>
                <th style={{ padding: '6px 12px', fontWeight: 600, color: '#000000', width: '35%' }}>Reason</th>
              </tr>
            </thead>
            <tbody>
              {failedMeetings.map((m, index) => (
                <tr key={m.id} style={{ backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F2F2F2', borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '6px 12px',color: '#000000' }}>{index + 1}</td>
                  <td style={{ padding: '6px 12px', color: '#000000' }}>{m.meetingName || '-'}</td>
                  <td style={{ padding: '6px 12px', color: '#000000' }}>{m.date || '-'}</td>
                  <td style={{ padding: '6px 12px', color: '#000000' }}>{m.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
